import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PasswordResetResult, PasswordResetService } from 'src/app/services/common/password-reset.service';

export enum ForgotPasswordState {
  Initial,
  Loading,
  Success,
  RateLimited,
  Error
}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordFG!: FormGroup;
  emailFC!: FormControl<string | null>;

  state: ForgotPasswordState = ForgotPasswordState.Initial;
  readonly ForgotPasswordState = ForgotPasswordState;

  constructor(
    private passwordResetService: PasswordResetService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.emailFC = new FormControl<string | null>('', [
      Validators.required,
      Validators.email
    ]);

    this.forgotPasswordFG = new FormGroup({
      emailFC: this.emailFC
    });
  }

  get isLoading(): boolean {
    return this.state === ForgotPasswordState.Loading;
  }

  public async requestPasswordReset(): Promise<void> {
    if (this.forgotPasswordFG.invalid) {
      this.emailFC.markAsTouched();
      return;
    }

    this.state = ForgotPasswordState.Loading;

    const email = (this.emailFC.value ?? '').trim();

    try {
      const result = await this.passwordResetService.requestPasswordReset(email);

      switch (result) {
        case PasswordResetResult.Success:
          this.state = ForgotPasswordState.Success;
          break;
        case PasswordResetResult.RateLimited:
          this.state = ForgotPasswordState.RateLimited;
          break;
        case PasswordResetResult.Error:
          this.state = ForgotPasswordState.Error;
          break;
      }
    } catch (error) {
      this.state = ForgotPasswordState.Error;
    }
  }

  public goToLogin(): void {
    this.router.navigate(['/login']);
  }

  public resetForm(): void {
    this.state = ForgotPasswordState.Initial;
    this.forgotPasswordFG.reset();
  }
}
